"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialColorSearchModel = instanceOfMaterialColorSearchModel;
exports.MaterialColorSearchModelFromJSON = MaterialColorSearchModelFromJSON;
exports.MaterialColorSearchModelFromJSONTyped = MaterialColorSearchModelFromJSONTyped;
exports.MaterialColorSearchModelToJSON = MaterialColorSearchModelToJSON;
exports.MaterialColorSearchModelToJSONTyped = MaterialColorSearchModelToJSONTyped;
/**
 * Check if a given object implements the MaterialColorSearchModel interface.
 */
function instanceOfMaterialColorSearchModel(value) {
    return true;
}
function MaterialColorSearchModelFromJSON(json) {
    return MaterialColorSearchModelFromJSONTyped(json, false);
}
function MaterialColorSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'mdMaterialNo': json['mdMaterialNo'] == null ? undefined : json['mdMaterialNo'],
        'colorName': json['colorName'] == null ? undefined : json['colorName'],
    };
}
function MaterialColorSearchModelToJSON(json) {
    return MaterialColorSearchModelToJSONTyped(json, false);
}
function MaterialColorSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'mdMaterialNo': value['mdMaterialNo'],
        'colorName': value['colorName'],
    };
}
